import gql from "graphql-tag";

export const deletedCollectionData = gql`
  mutation deletedCollectionData(
    $input: DeletedCollectionDataInput!) {
    deletedCollectionData(input: $input) {
      project {
        id
        updatedAt
        collections {
          id
          index
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
        }
      }
    }
  }
`;

export const deletedCollectionDataOptions = {
  name: "deletedCollectionData",
};
